import React from 'react';
import { ICommentData } from '../../../types/order/comment/IComment';
import { CommentContent } from './CommentContent';
import { BodyText } from '../../../ui-toolkit';

const sortByCreation = (a: ICommentData, b: ICommentData) => {
  if (a.createdAt < b.createdAt) return 1;
  return a.createdAt > b.createdAt ? -1 : 0;
};

const sortComments = (comments?: ICommentData[]): ICommentData[] =>
  comments ? [...comments].sort(sortByCreation) : [];

export const CommentsView: React.FC<{ comments?: ICommentData[] }> = ({ comments }) => {
  const sortedComments = sortComments(comments);
  return (
    <>
      {sortedComments.length ? (
        sortedComments.map((comment: ICommentData) => <CommentContent comment={comment} key={comment.id} />)
      ) : (
        <BodyText>No comments yet</BodyText>
      )}
    </>
  );
};
